module.exports = __webpack_public_path__ + "media/images/normas-ba_icon_32-841b3dd9b4753c7ad88bf62ff3d45e9c.png";